// #region imports

// --- angular
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// 3rd Party
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

// --- HS Code
import * as c from './';
import { CookiePolicyModule } from './cookie-policy/cookie-policy.module';

@NgModule({
  declarations: [ c.AppToastComponent ],
  imports: [ CommonModule, CookiePolicyModule, NgbModule, RouterModule, TranslateModule ],
  exports: [ c.AppToastComponent, CookiePolicyModule, NgbModule ],
})
export class CoreModule extends c.EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    super(parentModule);
  }
}
